import {updateLabelConfig} from '../../../../data/labelInfos/index.js'
import {DHL} from '../../../../common/constants/ShipperNames.js'
import ConfigTextInput from '../ConfigTextInput.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from '../useLabelProperty.js'

const LABEL_PROPERTY = 'federal_tax_id'
const VALID_SHIPPER_TYPES = [DHL]

export default function FederalTaxID() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = FederalTaxID.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigTextInput
      label="Federal Tax ID"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {[LABEL_PROPERTY]: value})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

FederalTaxID.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
